// Available Endorsements Response (POST applications/availableEndorsements)
// {
//   "availableEndorsements": {
//     "equipmentBreakdownEndorsement": "true",
//   }
// }
//
// Application Update Payload (POST applications)
// {
//   "endorsements": {
//     "equipmentBreakdownEndorsement": true
//   }
// }
import { useSelector, useDispatch } from 'react-redux';
import { setEquipmentBreakdownCoverage, setCheckedEndorsement } from '../../../../actions/application';
import { selectCheckedEndorsements } from '../../../../selectors/application';
import EndorsementCard from '../../EndorsementCard';
import { config } from './EquipmentBreakdown.config';

const { endorsementKey: ENDORSEMENT_KEY, label: LABEL, description: DESCRIPTION } = config;

const EquipmentBreakdown = () => {
  const dispatch = useDispatch();
  const isSelected = useSelector(selectCheckedEndorsements).includes(ENDORSEMENT_KEY);

  const handleCheckboxChange = (checked: boolean) => {
    dispatch(setCheckedEndorsement(ENDORSEMENT_KEY, checked));
    dispatch(setEquipmentBreakdownCoverage(checked ? true : null));
  };

  return (
    <EndorsementCard
      endorsementKey={ENDORSEMENT_KEY}
      label={LABEL}
      description={DESCRIPTION}
      isSelected={isSelected}
      onCheckboxChange={handleCheckboxChange}
    />
  );
};

export default EquipmentBreakdown;
